import { vctooltip } from '@coreui/vue-pro'

// CoreUI 5's v-c-tooltip crashes on a null/undefined binding value (it reads
// value.content in mounted); skip the tooltip for empty values instead.
function resolveContent(value) {
  if (value == null) {
    return ''
  }

  return typeof value === 'string' ? value : (value.content ?? '')
}

export default {
  ...vctooltip,
  mounted(el, binding, vnode, prevVnode) {
    if (!resolveContent(binding.value)) {
      return
    }

    vctooltip.mounted(el, binding, vnode, prevVnode)
  }
}
